import axios from 'axios';
import { registerAdditionalHeadersInterceptor } from '@creditornot/converse-shared';
import { getTokenDataFromStorage, removeTokenDataFromStorage } from './utils';
import { apiUrlByEnv } from './constants';
export const maybeLogoutUser = (params) => {
    const tokenData = getTokenDataFromStorage('workspace');
    if (!tokenData) {
        return;
    }
    const axiosInstance = axios.create();
    registerAdditionalHeadersInterceptor({ hostName: params.host.name, hostRevision: params.host.revision }, axiosInstance);
    removeTokenDataFromStorage('workspace');
    axios
        .post(`${apiUrlByEnv[params.env]}/workspace-api/v1/wolt/user/logout`, {
        refreshToken: tokenData.refreshToken,
    })
        // silencing "unhandled promise rejection" errors as this is not intended to be used in an async way
        .catch(() => { });
};
export const maybeLogoutContact = (appId, params) => {
    const tokenData = getTokenDataFromStorage('widget');
    if (!tokenData) {
        return;
    }
    const axiosInstance = axios.create();
    registerAdditionalHeadersInterceptor({ hostName: params.host.name, hostRevision: params.host.revision }, axiosInstance);
    removeTokenDataFromStorage('widget');
    axios
        .post(`${apiUrlByEnv[params.env]}/widget-api/v1/${appId}/contact/logout`, {
        refreshToken: tokenData.refreshToken,
    })
        // silencing "unhandled promise rejection" errors as this is not intended to be used in an async way
        .catch(() => { });
};
//# sourceMappingURL=logout.js.map